import { Component, OnInit } from "@angular/core";
import { DevicesService } from "../../devices/devices.service";
import { EnergyService } from "../energy.service";
import { SessionStateService } from "../../../core/services/session-state.service";
import { GeneralService } from "../../../shared/services/general.service";
import { HOUSE_COUNTRIES } from "../../houses/houses.constants";

@Component({
  selector: "app-energy-prediction",
  templateUrl: "./energy-prediction.component.html",
  styleUrls: ["./energy-prediction.component.scss"],
})
export class EnergyPredictionComponent implements OnInit {
  today: Date = new Date(Date.now());
  activeView = "month";
  mode = "Eur";

  loaded = false;

  public contractedPower;
  public energyTotal: number;
  public taxes: number;
  public dged: number;
  public audiovisual: number;
  public totalIva: number;
  public total: number;
  public costPlanFee;
  public isSpainCountry: boolean;
  public lastPrediction = false;
  graphReadings;

  smartReaderDevice: any;
  // CHARTS
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          stacked: true,
          gridLines: {
            color: "#ECECEC",
            display: false,
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          gridLines: {
            color: "#ECECEC",
            display: true,
          },
          ticks: { min: 0 },
        },
      ],
    },
  };

  constructor(
    private devicesService: DevicesService,
    private sessionStateService: SessionStateService,
    private energyService: EnergyService,
    private generalService: GeneralService
  ) {}

  ngOnInit() {
    this.isSpainCountry =
      this.sessionStateService.getHouse().country === HOUSE_COUNTRIES.SPAIN;
    this.devicesService
      .getSmartMeter(this.sessionStateService.getHouse().houseId)
      .subscribe((smartMeter: any) => {
        this.smartReaderDevice = smartMeter[0];
        this.energyService
          .getPredictionTotal(this.sessionStateService.getHouse().houseId)
          .subscribe((totals) => {
            if (typeof totals !== "boolean") {
              this.dged = totals["DGEGExplorationTax"];
              this.audiovisual =
                totals["audiovisualContribution"] +
                totals["audiovisualContributionTax"];
              this.totalIva = totals["tax"];
              this.total = totals["total"];
              this.energyTotal = totals["energyPrediction"].cost;
              this.contractedPower = totals["contractedPowerCost"];
              if (totals["impuestoElectrico"]) {
                this.taxes = totals["impuestoElectrico"];
              }
            }
          });
        this.loaded = true;
      });
  }

  changeMode(event) {
    this.mode = event;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy-prediction/energy-prediction.component.ts